import * as actionTypes from './actionTypes';

export const openModalError = (message?: string, href?: string) => ({
  type: actionTypes.OPEN_MODAL_ERROR,
  show: true,
  message,
  href
});

export const closeModalError = () => ({
  type: actionTypes.CLOSE_MODAL_ERROR,
  show: false
});
